var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',{attrs:{"colspan":_vm.colspan}},[_vm._t("no-data",function(){return [_c('div',{staticClass:"d-flex align-center h-30px"},[_c('p',{staticClass:"my-0 mx-2 caption text-gray-400"},[_vm._v(_vm._s(_vm.text))])])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }